import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className='lg:px-24 md:px-4 px-2 py-20 mt-12 bg-[#090833] text-white movie flex flex-col items-start'>
            <div className="mb-3">
                <h2 className='text-[18px] text-left text-[#e6e101]'>Privacy Policy</h2>
                <p>This Privacy Policy explains how we collect, use, and disclose information about visitors to our movie website. By using our website, you consent to the collection, use, and disclosure of your information as described in this Privacy Policy.</p>
            </div>

            <div className="mb-3">
                <h2 className='text-[18px] text-left text-[#e6e101]'>Information We Collect</h2>
                <p>We may collect personal information that you provide to us, such as your name and email address, when you sign up for our newsletter, participate in a contest or survey, or contact us for support. We may also collect information about your device, such as your IP address, browser type, and operating system. <br /><br />

                    We may use cookies and similar tracking technologies to collect information about your use of our website, such as the pages you visit and the links you click. Most web browsers automatically accept cookies, but you can modify your browser settings to decline cookies if you prefer.</p>
            </div>

            <div className="mb-3">
                <h2 className='text-[18px] text-left text-[#e6e101]'>Your Choices</h2>
                <p>You can unsubscribe from our newsletters and promotional materials at any time by clicking the "unsubscribe" link in the email. You can also disable cookies by modifying your browser settings.</p>
            </div>

            <div className="mb-3">
                <h2 className='text-[18px] text-left text-[#e6e101]'>Children's Privacy</h2>
                <p>Our website is not intended for children under the age of 13, and we do not knowingly collect personal information from children under the age of 13. If we become aware that we have collected personal information from a child under the age of 13, we will take reasonable steps to delete the information as soon as possible.</p>
            </div>

            <div className="mb-3">
                <h2 className='text-[18px] text-left text-[#e6e101]'>Security</h2>
                <p>We take reasonable measures to protect your personal information from unauthorized access, disclosure, alteration, and destruction. However, no method of transmission over the internet or method of electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
            </div>

            <div className="mb-3">
                <h2 className='text-[18px] text-left text-[#e6e101]'>Changes to This Privacy Policy</h2>
                <p>We may update this Privacy Policy from time to time. If we make material changes, we will notify you by email or by posting a notice on our website prior to the change becoming effective. We encourage you to review this Privacy Policy periodically for any changes.</p>
            </div>

            <div className="mb-3">
                <h2 className='text-[18px] text-left text-[#e6e101]'>Contact Us</h2>
                <p>If you wanted to share your opinion about our privacy policy system please contact on social media us and give your comment</p>
            </div>


        </div>
    );
};

export default PrivacyPolicy;